import { useState } from 'react';
import { dbPost } from '../../apis/commonApi';


class AllowIpController {
    headerList = [
        {
        colNo: 0,
        key: 'selected',
        labelType: 'check',
        dataType: 'check',
        name: '선택',
        readonly: false,
        },
        {
        colNo: 1,
        key: 'ipAddr',
        labelType: 'text',
        dataType: 'inputText',
        name: 'IP 주소',
        readonly: false,
        },
        {
        colNo: 2,
        key: 'entNm',
        labelType: 'text',
        dataType: 'inputText',
        name: '사용자',
        readonly: false,
        },
        {
        colNo: 3,
        key: 'useYn',
        labelType: 'text',
        dataType: 'select',
        name: '상태',
        readonly: false,
        selectList: [
            { value: 'Y', label: '허용' },
            { value: 'N', label: '차단' },
        ],
    },
    ];

    constructor(
        store,
        modalService,
        validateService,
        refs,
        {
        valueObj,
        setValueObj,
        dataList,
        setDataList,
        deletedRows,
        setDeletedRows,
        originalDataList,
        setOriginalDataList,
        }
    ) {
        this.store = store;
        this.modalService = modalService;
        this.validateService = validateService;
        this.tableRef = refs[0];
        this.valueObj = { ...valueObj };
        this.setValueObj = setValueObj;
        this.dataList = dataList || [];
        this.setDataList = setDataList;
        this.deletedRows = deletedRows;
        this.setDeletedRows = setDeletedRows;
        this.originalDataList = originalDataList || [];
        this.setOriginalDataList = setOriginalDataList;
    }

    //IP 리스트
    async loadIpList() {
    try {
        const url = '/system/ip/list.do';
        const response = await dbPost(url, {});

        if (!Array.isArray(response)) {
            throw new Error(response?.message || 'Failed to fetch IP list.');
        }

        const newDataList = response.map((item, index) => ({
            rowNo: index + 1,
            prmIpId: item.prmIpId,
            ipAddr: item.ipAddr || '',
            entNm: item.entNm || '',
            selected: false,
            useYn: item.useYn || 'Y',
        }));
        
        this.setOriginalDataList(newDataList);
        this.setDataList(newDataList);
    } catch (error) {
    }
}

    // 작업 테이블 헤더 체크박스
    async tableHeaderClick(info) {
        let tableData = this.tableRef.current.getDataList();

        if (info.keyVal === 'selected') {
        for (let index = 0; index < tableData.length; index++) {
            tableData[index].selected = info.val;
        }

        this.tableRef.current.setDataList(tableData);
        }
    }

    async saveChanges() {
        try {
            if (this.deletedRows.length > 0) {
                for (const row of this.deletedRows) {
                    if (row.prmIpId) {
                        await dbPost('/system/ip/remove.do', { prmIpId: row.prmIpId });
                    } else {
                    }
                }
            }

            const addedRows = this.dataList.filter(row => !row.prmIpId); // prmIpId가 없는 행은 새로 추가된 행
            for (const row of addedRows) {
                if (!row.ipAddr || !row.entNm) {
                    this.modalService.errorAlert('모든 필수 정보를 입력해 주세요.');
                    return;
                }
                await dbPost('/system/ip/add.do', {
                    ipAddr: row.ipAddr,
                    entNm: row.entNm,
                    useYn: row.useYn,
                });
            }

            const updatedRows = this.dataList.filter(
                row =>
                    row.prmIpId && // 기존에 존재하던 행
                    !this.deletedRows.some(deleted => deleted.prmIpId === row.prmIpId) && // 삭제되지 않은 행
                    (row.ipAddr !== this.originalDataList.find(original => original.prmIpId === row.prmIpId)?.ipAddr || 
                    row.entNm !== this.originalDataList.find(original => original.prmIpId === row.prmIpId)?.entNm || 
                    row.useYn !== this.originalDataList.find(original => original.prmIpId === row.prmIpId)?.useYn) // 변경된 항목만
            );
            for (const row of updatedRows) {
                if (!row.ipAddr || !row.entNm) {
                    this.modalService.errorAlert('모든 필수 정보를 입력해 주세요.');
                    return;
                }
                await dbPost('/system/ip/modify.do', {
                    prmIpId: row.prmIpId,
                    ipAddr: row.ipAddr,
                    entNm: row.entNm,
                    useYn: row.useYn,
                });
            }

            this.setDeletedRows([]); // 삭제 목록 초기화
            await this.loadIpList(); // 변경 사항 적용 후 리스트 재조회

            alert('변경 사항이 성공적으로 저장되었습니다.');
        } catch (error) {
            alert('저장 중 오류가 발생했습니다.');
        }
    }

    deleteRow() {
    const selectedRows = this.dataList.filter(row => row.selected);
    
    if (selectedRows.length === 0) {
        this.modalService.errorAlert('삭제할 행을 먼저 선택해주세요.');
        return;
    }

    this.modalService.confirmAlert({ msg: '삭제하시겠습니까?' }, [
        () => {
            const updatedDataList = this.dataList.filter(row => !row.selected);
            this.setDeletedRows(prev => [...prev, ...selectedRows]); 
            this.setDataList(updatedDataList);
        },
        () => {}
    ]);
}
}


export default AllowIpController;